/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ContainerModel, TableModel } from '@typescript-kit/view';
import { TimeRecordingMenuComponentModel } from './time-recording-menu.component-model';

export class EmployeeTimeRecordingDetailComponentModel extends ContainerModel {

  get menuModel(): TimeRecordingMenuComponentModel {
    return this.items.get('menu') as TimeRecordingMenuComponentModel;
  }

  get tableModel(): TableModel {
    return this.items.get('table') as TableModel;
  }

  get summaryModel(): ContainerModel {
    return this.items.get('summary') as ContainerModel;
  }

}
